import { HTTPStatusCode } from "@libs/api/types";
import { CheckCoverageBodyType } from "@/domain/coverage";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const CoverageApi = {
  checkCoverage: async (params: CheckCoverageBodyType) => {
    const res = await tsRestClient().coverage.checkCoverage({
      body: params,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to check coverage",
      shouldThrowError: true,
    });
  },
};
